// import {  Navigate , Outlet } from "react-router-dom";
// import useAuth from "../hook/useAuth";

// const Auth=() =>{
//     const ctx = useAuth();
//     return (
//         (ctx?.username !=="" && ctx?.username !==null) ? <Outlet/> : <Navigate to="/login"  replace/>
//     )
// }

// export default Auth;

import { Navigate, Outlet } from 'react-router-dom'

const Auth = ({ keycloak }) => {
  // Step 1: While keycloak instance is loading, return nothing
  if (!keycloak) return null

  // Step 2: If user is not authenticated → redirect to Keycloak login
  if (!keycloak.authenticated) {
    keycloak.login() // automatically redirects
    return null // prevent rendering anything before redirect
  }

  // Step 3: User is authenticated → allow protected routes
  return <Outlet />
}

export default Auth
 